import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import Icon from '../../../components/AppIcon';

const PractitionerPerformanceMetrics = ({ performance, loading }) => {
  if (loading) {
    return (
      <div className="glass-card p-6 rounded-2xl">
        <div className="animate-pulse">
          <div className="h-6 bg-gray-200 rounded w-1/3 mb-4"></div>
          <div className="h-64 bg-gray-100 rounded"></div>
        </div>
      </div>
    );
  }

  const chartData = performance?.topDentists?.slice(0, 5)?.map(dentist => ({
    name: dentist?.name?.length > 20 ? dentist?.name?.substring(0, 20) + '...' : dentist?.name,
    total: dentist?.totalReferrals,
    completed: dentist?.completed,
    pending: dentist?.pending
  }));

  return (
    <div className="glass-card p-6 rounded-2xl">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-xl bg-success/10 flex items-center justify-center">
          <Icon name="Users" size={20} className="text-success" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-foreground">Performance des praticiens</h3>
          <p className="text-sm text-muted-foreground">Top 5 dentistes adresseurs</p>
        </div>
      </div>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis 
            dataKey="name" 
            stroke="#6b7280"
            style={{ fontSize: '11px' }}
            angle={-45}
            textAnchor="end"
            height={80}
          />
          <YAxis 
            stroke="#6b7280"
            style={{ fontSize: '12px' }}
          />
          <Tooltip 
            contentStyle={{
              backgroundColor: 'rgba(255, 255, 255, 0.95)',
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
            }}
          />
          <Legend />
          <Bar dataKey="total" fill="#2563eb" name="Total" radius={[8, 8, 0, 0]} />
          <Bar dataKey="completed" fill="#10b981" name="Terminés" radius={[8, 8, 0, 0]} />
          <Bar dataKey="pending" fill="#f59e0b" name="En attente" radius={[8, 8, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
      <div className="grid grid-cols-2 gap-4 mt-6 pt-6 border-t border-gray-200">
        <div>
          <p className="text-sm text-muted-foreground mb-1">Dentistes actifs</p>
          <p className="text-2xl font-bold text-foreground">{performance?.totalUniqueDentists || 0}</p>
        </div>
        <div>
          <p className="text-sm text-muted-foreground mb-1">Total adressages</p>
          <p className="text-2xl font-bold text-foreground">{performance?.totalReferrals || 0}</p>
        </div>
      </div>
      {/* Detailed list */}
      <div className="mt-6 space-y-3">
        <h4 className="text-sm font-semibold text-foreground mb-3">Détails des performances</h4>
        {performance?.topDentists?.slice(0, 5)?.map((dentist, index) => (
          <div key={index} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
            <div className="flex-1">
              <p className="text-sm font-medium text-foreground">{dentist?.name}</p>
              <p className="text-xs text-muted-foreground">
                {dentist?.totalReferrals} adressages • {dentist?.completed} terminés
              </p>
            </div>
            <div className="text-right">
              <p className="text-sm font-semibold text-primary">
                {dentist?.avgResponseTime > 0 ? `${Math.round(dentist?.avgResponseTime)}h` : 'N/A'}
              </p>
              <p className="text-xs text-muted-foreground">Temps réponse</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PractitionerPerformanceMetrics;